export const PARAM_MEMBER_ID = '{memberId}';
